module.exports = __webpack_public_path__ + "img/work_15.c5674a9c.png";